import { Heading } from '@spark-web/heading';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';

import { Button as BrighteButton } from '~/components/common/button';
import { useLeadContext } from '~/provider/LeadProvider';
import { CustomerFormValues } from '~/types/marketplace';

import { Footer } from '../footer';

type CallbackFormProps = {
  onSubmit: (data: Partial<CustomerFormValues>) => void;
  isLoading: boolean;
};

export const CallbackForm = ({ isLoading, onSubmit }: CallbackFormProps) => {
  const { lead: customer } = useLeadContext();

  return (
    <Stack gap="xxlarge">
      <Heading level="2">{customer?.contact?.firstName}, need help with your upgrades?</Heading>
      <Text size="small">
        You can speak to an expert at Brighte who can guide you through finding the best solutions and vendors for your
        home.
      </Text>
      <Stack gap="xlarge">
        <BrighteButton rounded type="submit" loading={isLoading} onClick={() => onSubmit({ leadId: customer?.id })}>
          Request a call back
        </BrighteButton>
        <Footer />
      </Stack>
    </Stack>
  );
};
